import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { AuthservicesService } from 'src/app/services/authservices.service';

@Component({
  selector: 'app-shared-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit {
  show = false

  faithResults
  totalItems
  pageSize
  loading
  showButton = false
  loadMoreArr
  closeResult: string;
  modalOptions: NgbModalOptions;
  checkbox = []
  faithName = ""
  faithid
  staticButton
  Title
  defaultBounds
  loadershow = false
  event = ''
  arr = [1, 23, 4, 5]
  form: FormGroup
  addr

  @Output() setAddress: EventEmitter<any> = new EventEmitter();

  constructor(private modalService: NgbModal, private authService: AuthservicesService, private router: Router, private fb: FormBuilder) {
    this.pageSize = 3

  }
  ngOnInit(): void {
    this.getLocation()
    this.form = this.fb.group({
      denominiation: [''],
      faith: [''],
      state: [''],
      country: [''],
      long: [''],
      lat: [''],
      areaCode: [''],
      city: [''],
      search: [''],skip:[''],
      limit:['']
    })

  }

  open(content, title) {
    this.Title = title

    if (title == 'faith') {
      this.loading = false;
      this.loadMoreArr = [];
      this.checkbox.pop()
      this.staticButton = false
      this.getFaith(0)
    }


    this.modalService.open(content, { scrollable: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        if (position) {
          console.log("Latitude: " + position.coords.latitude +
            "Longitude: " + position.coords.longitude);
          this.defaultBounds = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }

        }
      },
        (error) => console.log(error));
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }


  shows() {
    this.show = true
    setTimeout(() => {
      this.loadershow = true
    }, 1500)

  }

  getAddress(event) {
    console.log(event, 'dsadsa')
    setTimeout(() => {
      this.show = false
      this.event = event.googleAddress

      this.form.get('lat').setValue(event.location.coordinates[0])
      this.form.get('long').setValue(event.location.coordinates[1])


    }, 500)
  }

  onSubmit() {

    let formObj = this.form.value


    this.setAddress.emit(formObj)
  }



  getFaith(event) {
    this.showButton = true
    let skip = event
    this.authService.getFaith(skip, this.pageSize).subscribe((res: any) => {
      this.loading = true
      this.faithResults = this.createArray(res.items, 'faith')
      this.totalItems = res.total
      this.concatArray(this.faithResults, this.totalItems)
    },
      error => {
        console.log(error)
      }
    )
  }
  createArray(arr, type) {
    let data = []
    arr.forEach(e => {
      data.push({
        '_id': e._id,
        'name': e.name,
        'photo': e.photo,
        'description': (!e.description) ? e.shortBio : e.description,
        'type': type
      })
    });
    return data
  }

  concatArray(arr, total) {
    if (arr.length != 0) { this.loadMoreArr = this.loadMoreArr.concat(arr) }
    else if (arr.length == 0) {
      this.showButton = false
    }
    if (this.loadMoreArr.length == total && this.loadMoreArr.length != 0) this.showButton = false
  }






  showMore() {
    const skip = this.loadMoreArr.length
    this.getFaith(skip)
  }

  selectItem(e, props) {

    if (this.checkbox.length < 1 && e.target.checked) {
      this.faithid = props._id;
      this.form.get('faith').setValue(this.faithid)
      this.faithName = props.name;
      this.form.get('denominiation').setValue(this.faithName)

      this.checkbox.push(e.target.value);
    }

    else if (e.target.checked == false) {
      this.checkbox.pop();
    }
    else {
      e.target.checked = false;
    }
  }



  // ngOnChanges(changes: SimpleChanges) {


  //   if (changes['strictBounds']['previousValue'] != undefined) {
  //     console.log(changes, 'changes')
  //     this.getPlaceAutocomplete();
  //   }
  // }









  getErrorImage(event) {
    this.authService.geterrorImage(event);

  }

}
